import { MfaVerify } from '@/features/mfa'

const MfaVerifyPage = () => <MfaVerify />

export default MfaVerifyPage
